import ChartAPI from "../../apps/common/chart-api";

// Yandex.Metrika counter
(function (m, e, t, r, i, k, a) {
  m[i] =
    m[i] ||
    function () {
      (m[i].a = m[i].a || []).push(arguments);
    };
  m[i].l = 1 * new Date();
  for (var j = 0; j < document.scripts.length; j++) {
    if (document.scripts[j].src === r) {
      return;
    }
  }
  (k = e.createElement(t)),
    (a = e.getElementsByTagName(t)[0]),
    (k.async = 1),
    (k.src = r),
    a.parentNode.insertBefore(k, a);
})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(91126829, "init", {
  clickmap: true,
  trackLinks: true,
  accurateTrackBounce: true,
  webvisor: true,
});

function parseQueryString(queryString) {
  let params = {};
  queryString.replace(/^\?/, '').split('&').forEach(pair => {
    if (!pair) return;
    let [key, value] = pair.split('=');
    params[key] = decodeURIComponent(value || '');
  });
  return params;
}

export default {
  namespaced: true,
  state: {
    keywordsStats: [],
    keywordsStatsPeriod: "",
    loadingKeywords: false,
    topPersistenceFilterType: {
      title: "Больше",
      value: "results_in_top_gt",
    },
    topPersistenceFilterTypeOptions: [
      {
        title: "Больше",
        value: "results_in_top_gt",
      },
      {
        title: "Меньше",
        value: "results_in_top_lt",
      },
    ],
    topPersistenceFilterValue: null,
    filterByOptions: [
      {
        title: "Средняя позиция",
        value: "mean_position",
      },
      {
        title: "SOV",
        value: "sov",
      },
      {
        title: "Доля премиум-показов",
        value: "percent",
      },
    ],
    filterBy: {
      title: "Средняя позиция",
      value: "mean_position",
    },
    paginationPageNumber: 1,
    pageItems: 1,
    currentPaginationPage: 1,
    rowsPaginationNumber: 1,
  },
  actions: {
    resetState({ commit }) {
      commit("updateKeywordsStats", []);
      commit("updateCurrentPaginationPage", 1);
      commit("updateRowsPaginationNumber", 0);
    },
    async fetchKeywordsStats({ commit, dispatch, rootGetters, getters }) {
      if (rootGetters["currentProjectId"] == null) {
        return;
      }
      commit("updateKeywordsStats", []);
      commit("updateLoading", true);
      commit("updateFilterBy", getters["filterBy"]);
      commit(
        "updateTopPersistenceFilterType",
        getters["topPersistenceFilterType"]
      );
      try {
        let studObj = new ChartAPI();
        const reportPageItems = 50;
        commit("updatePageItems", reportPageItems)
        let queryParams = parseQueryString(getters["keywordsDownloadLink"]);
        queryParams.page = getters['currentPaginationPage'];
        let jsonResponse = await studObj.sendRequest(
          "getKeywordsStats",
          rootGetters["currentProjectId"],
          null,
          queryParams
        );
        let items = [];
        let results = (jsonResponse && jsonResponse["results"]) ? jsonResponse["results"] : [];
        if (results.length) {
          for (let element in results) {
            if (results.hasOwnProperty(element)) {
              const meanPos = results[element]["mean_position"];
              const sovVal = results[element]["sov"];
              const resultsInTopVal = results[element]["results_in_top"];
              const formatNum = (val, decimals) => {
                if (val === "-" || val === null || val === undefined) return "—";
                const n = parseFloat(val);
                if (Number.isNaN(n)) return "—";
                return decimals === 0 ? n.toFixed(0) : n.toFixed(decimals);
              };
              const formatPct = (val) => {
                const s = formatNum(val, 0);
                return s === "—" ? "—" : `${s}%`;
              };
              items.push({
                keyword: results[element]["keyword"],
                meanPosition: formatNum(meanPos, 2),
                resultsInTop: formatPct(resultsInTopVal),
                sov: formatPct(sovVal),
              });
            }
          }
        }
        commit("updateRowsPaginationNumber", jsonResponse && jsonResponse["count"] ? jsonResponse["count"] : 0);
        commit("updateKeywordsStats", items);
      } finally {
        commit("updateLoading", false);
      }
    },
    updatePaginationPageNumber(state, paginationPageNumber) {
      state.paginationPageNumber = paginationPageNumber;
    },
    selectPaginationPageNumber({commit}, paginationPageNumber) {
      commit("updatePaginationPageNumber", paginationPageNumber);
    },
    selectCurrentPaginationPage({commit}, currentPaginationPage) {
      commit("updateCurrentPaginationPage", currentPaginationPage);
    },
    selectFilterBy({ commit }, filterBy) {
      commit("updateFilterBy", filterBy);
    },
    selectTopPersistenceFilterType({ commit }, topPersistenceFilterType) {
      commit("updateTopPersistenceFilterType", topPersistenceFilterType);
    },
    selectTopPersistenceFilterValue({ commit }, topPersistenceFilterValue) {
      commit("updateTopPersistenceFilterValue", topPersistenceFilterValue);
    },
  },
  mutations: {
    updatePageItems(state, pageItems) {
      state.pageItems = pageItems;
    },
    updateCurrentPaginationPage(state, currentPaginationPage) {
      state.currentPaginationPage = currentPaginationPage;
    },
    updateRowsPaginationNumber(state, rowsPaginationNumber) {
      state.rowsPaginationNumber = rowsPaginationNumber;
    },
    updateKeywordsStats(state, keywordsStats) {
      state.keywordsStats = keywordsStats;
    },
    updateLoading(state, loading) {
      state.loadingKeywords = loading;
    },
    updateFilterBy(state, filterBy) {
      state.filterBy = filterBy;
    },

    updateTopPersistenceFilterType(state, topPersistenceFilterType) {
      if (state.filterBy.value === "mean_position") {
        if (state.topPersistenceFilterType.title === "Больше")
          topPersistenceFilterType.value = "mean_position_gt";
        else topPersistenceFilterType.value = "mean_position_lt";
      } else if (state.filterBy.value === "sov") {
        if (state.topPersistenceFilterType.title === "Больше")
          topPersistenceFilterType.value = "sov_gt";
        else topPersistenceFilterType.value = "sov_lt";
      } else if (state.filterBy.value === "percent") {
        if (state.topPersistenceFilterType.title === "Больше")
          topPersistenceFilterType.value = "results_in_top_gt";
        else topPersistenceFilterType.value = "results_in_top_lt";
      }
      state.topPersistenceFilterType = topPersistenceFilterType;
    },

    updateTopPersistenceFilterValue(state, topPersistenceFilterValue) {
      state.topPersistenceFilterValue = topPersistenceFilterValue;
    },

    updateKeywordsStatsPeriod(state, keywordsStatsPeriod) {
      state.keywordsStatsPeriod = keywordsStatsPeriod;
    },
  },
  getters: {
    paginationPageNumber(state) {
      return state.paginationPageNumber;
    },
    pageItems(state) {
      return state.pageItems;
    },
    currentPaginationPage(state) {
      return state.currentPaginationPage;
    },
    rowsPaginationNumber(state) {
      return state.rowsPaginationNumber;
    },
    keywordsStats(state) {
      return state.keywordsStats;
    },
    topPersistenceFilterType(state) {
      return state.topPersistenceFilterType;
    },
    topPersistenceFilterTypeOptions(state) {
      return state.topPersistenceFilterTypeOptions;
    },
    topPersistenceFilterValue(state) {
      return state.topPersistenceFilterValue;
    },
    keywordsStatsPeriod(state) {
      return state.keywordsStatsPeriod;
    },
    keywordsDownloadLink(state, getters, rootState, rootGetters) {
      let keywordsLink =
        "?" +
        rootGetters["filters/dateRangeParam"] +
        rootGetters["filters/searchEngineParam"] +
        rootGetters["filters/deviceTypesParam"] +
        rootGetters["filters/keywordsParam"] +
        rootGetters["filters/keywordsTypesParam"] +
        rootGetters["filters/geoLocationsParam"] +
        rootGetters["filters/competitorsParam"];
      if (state.topPersistenceFilterValue && state.topPersistenceFilterType) {
        keywordsLink += `&${state.topPersistenceFilterType["value"]}=${state.topPersistenceFilterValue}`;
      }
      return keywordsLink;
    },
    filterBy(state) {
      return state.filterBy;
    },
    filterByOptions(state) {
      return state.filterByOptions;
    },
    loadingKeywords(state) {
      return state.loadingKeywords;
    },
  },
};
